import { Component, OnInit } from '@angular/core';
import { ServerTokenService } from '../../services/server-token.service';
import { FileUtils } from '../../utils/FIleUtils';

export class ReportSettingsActionCodeConfig {
  name!: string;
  label!: string;
  order!: number;
  isActive!: boolean;
  mergeWithName?: string;
}

export class ReportSettingsActionConfig {
  name!: string;
  label!: string;
  order!: number;
  isActive!: boolean;

  codes!: ReportSettingsActionCodeConfig[];
}

export class ActionConfigsWrapper {
  actionConfigs!: ReportSettingsActionConfig[];
}
export class ReferralConversions {
  reAdmissionCode!: string;
}

class HospitalTracker {
  tableCleaningCode!: string[];
  priorCodeToCleaning!: string[];
  returningToSnfCodes!: string[];
  deathABR!: string[];
}


export class ReportSettings {
  _id?: string;
  actionCodes!: ActionConfigsWrapper;
  actionTrends!: ActionConfigsWrapper;
  referralConversions!: ReferralConversions;

  hospitalTracker!: HospitalTracker;
  shortDescriptionMap!: { [key: string]: string };
  regionId!: number;

}

@Component({
  selector: 'ngx-action-codes-settings',
  templateUrl: './action-codes-settings.component.html',
  styleUrls: ['./action-codes-settings.component.scss']
})

export class ActionCodesSettingsComponent implements OnInit {

  ngOnInit(): void {
  }

  selectedReportType: string = 'actionCodes';
  reportTypes: string[] = ['actionCodes', 'actionTrends', 'referralConversions', 'hospitalTracker', 'shortDescriptionMap'];



  data: ReportSettings;
  oldDate: any;
  // {
  //   "actionConfigs": [
  //     {
  //       "name": "Admission",
  //       "label": "Admission",
  //       "order": 0,
  //       "isActive": true,
  //       "codes": [
  //         {
  //           "name": "AA",
  //           "label": "AA+RAA",
  //           "order": 0,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f88"
  //           }
  //         },
  //         {
  //           "name": "ReA",
  //           "label": "ReA",
  //           "order": 1,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f89"
  //           }
  //         },
  //         {
  //           "name": "RAA",
  //           "label": "RAA",
  //           "order": 2,
  //           "isActive": true,
  //           "mergeWithName": "AA"
  //         },
  //         {
  //           "name": "AHL",
  //           "label": "AHL",
  //           "order": 3,
  //           "isActive": true,
  //           "mergeWithName": "AA",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8b"
  //           }
  //         },
  //         {
  //           "name": "AR",
  //           "label": "AR",
  //           "order": 3,
  //           "isActive": true,
  //           "mergeWithName": "ReA",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8b"
  //           }
  //         },
  //         {
  //           "name": "AFH",
  //           "label": "AFH",
  //           "order": 3,
  //           "isActive": true,
  //           "mergeWithName": "AA"
  //         },
  //         {
  //           "name": "AGS",
  //           "label": "AGS",
  //           "order": 3,
  //           "isActive": true,
  //           "mergeWithName": "AA",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8b"
  //           }
  //         },
  //         {
  //           "name": "AOS",
  //           "label": "AOS",
  //           "order": 3,
  //           "isActive": true,
  //           "mergeWithName": "AA",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8b"
  //           }
  //         },
  //         {
  //           "name": "AOA",
  //           "label": "AOA",
  //           "order": 3,
  //           "isActive": true,
  //           "mergeWithName": "AA",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8b"
  //           }
  //         }
  //       ],
  //       "_id": {
  //         "$oid": "689deb4abe0efc83b47d7f87"
  //       }
  //     },
  //     {
  //       "name": "Discharge",
  //       "label": "Discharge",
  //       "order": 1,
  //       "isActive": true,
  //       "codes": [
  //         {
  //           "name": "D",
  //           "label": "D",
  //           "order": 0,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DTH",
  //           "label": "DTH",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DHL",
  //           "label": "DHL",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DOAF",
  //           "label": "DOAF",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DGA",
  //           "label": "DGA",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "RDD",
  //           "label": "RDD",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DGS",
  //           "label": "DGS",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DOS",
  //           "label": "DOS",
  //           "order": 0,
  //           "isActive": true,
  //           "mergeWithName": "D",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8d"
  //           }
  //         },
  //         {
  //           "name": "DAMA",
  //           "label": "DAMA",
  //           "order": 1,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f8e"
  //           }
  //         }
  //       ],
  //       "_id": {
  //         "$oid": "689deb4abe0efc83b47d7f8c"
  //       }
  //     },
  //     {
  //       "name": "Leave",
  //       "label": "Leave",
  //       "order": 2,
  //       "isActive": true,
  //       "codes": [
  //         {
  //           "name": "L",
  //           "label": "L",
  //           "order": 0,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f91"
  //           }
  //         },
  //         {
  //           "name": "TO",
  //           "label": "TO",
  //           "order": 1,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f92"
  //           }
  //         },
  //         {
  //           "name": "LOA",
  //           "label": "LOA",
  //           "order": 2,
  //           "isActive": true,
  //           "mergeWithName": "L",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f93"
  //           }
  //         },
  //         {
  //           "name": "TH",
  //           "label": "TH",
  //           "order": 2,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f93"
  //           },
  //           "mergeWithName": "TO"
  //         },
  //         {
  //           "name": "TOE",
  //           "label": "TOE",
  //           "order": 2,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f93"
  //           },
  //           "mergeWithName": "TO"
  //         }
  //       ],
  //       "_id": {
  //         "$oid": "689deb4abe0efc83b47d7f90"
  //       }
  //     },
  //     {
  //       "name": "Return from Leave",
  //       "label": "Return from Leave",
  //       "order": 3,
  //       "isActive": true,
  //       "codes": [
  //         {
  //           "name": "RHL",
  //           "label": "RHL",
  //           "mergeWithName": "RL",
  //           "order": 0,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f95"
  //           }
  //         },
  //         {
  //           "name": "RL",
  //           "label": "RL",
  //           "order": 1,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f96"
  //           }
  //         },
  //         {
  //           "name": "TI",
  //           "label": "TI",
  //           "order": 1,
  //           "isActive": true
  //         },
  //         {
  //           "name": "RFL",
  //           "label": "RFL",
  //           "order": 2,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f97"
  //           },
  //           "mergeWithName": "RL"
  //         },
  //         {
  //           "name": "TFE",
  //           "label": "TFE",
  //           "order": 2,
  //           "isActive": true,
  //           "mergeWithName": "RL",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f97"
  //           }
  //         }
  //       ],
  //       "_id": {
  //         "$oid": "689deb4abe0efc83b47d7f94"
  //       }
  //     },
  //     {
  //       "name": "Death",
  //       "label": "Death",
  //       "order": 4,
  //       "isActive": true,
  //       "codes": [
  //         {
  //           "name": "E",
  //           "label": "E",
  //           "order": 1,
  //           "isActive": true,
  //           "mergeWithName": "DE",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f9a"
  //           }
  //         },
  //         {
  //           "name": "DE",
  //           "label": "DE",
  //           "order": 1,
  //           "isActive": true,
  //           "mergeWithName": "",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f9a"
  //           }
  //         },
  //         {
  //           "name": "DH",
  //           "label": "DH",
  //           "order": 1,
  //           "isActive": true,
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f9a"
  //           }
  //         },
  //         {
  //           "name": "RDE",
  //           "label": "RDE",
  //           "order": 1,
  //           "isActive": true,
  //           "mergeWithName": "DE",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f9a"
  //           }
  //         },
  //         {
  //           "name": "RDH",
  //           "label": "RDH",
  //           "order": 1,
  //           "isActive": true,
  //           "mergeWithName": "DH",
  //           "_id": {
  //             "$oid": "689deb4abe0efc83b47d7f9a"
  //           }
  //         }
  //       ],
  //       "_id": {
  //         "$oid": "689deb4abe0efc83b47d7f98"
  //       }
  //     },
  //     {
  //       "name": "Internal Transfer",
  //       "label": "Internal Transfer",
  //       "order": 0,
  //       "isActive": false,
  //       "codes": [],
  //       "_id": {
  //         "$oid": "689deb4abe0efc83b47d7f9b"
  //       }
  //     },
  //     {
  //       "name": "Room Reserve",
  //       "label": "Room Reserve",
  //       "order": 5,
  //       "isActive": true,
  //       "codes": [
  //         {
  //           "name": "RR",
  //           "label": "RR",
  //           "order": 0,
  //           "isActive": true
  //         }
  //       ]
  //     }
  //   ]
  // }

  constructor(private server: ServerTokenService) {
    this.server.getWithToken<any>('snfs/admin/getReportSettings').toPromise().then(data => {
      this.oldDate = JSON.parse(JSON.stringify(data));
      this.data = data;
    });

    // Example: load via API
    // this.actionService.get().subscribe(data => this.actionCodes = data);

    // For test, paste your object directly:
    // this.actionCodes = YOUR_OBJECT;
  }

  addCode(cfgIndex: number) {
    this.data.actionCodes.actionConfigs[cfgIndex].codes.push({
      name: '',
      label: '',
      order: 0,
      isActive: true,
      mergeWithName: ''
    });
  }

  removeCode(cfgIndex: number, codeIndex: number) {
    this.data.actionCodes.actionConfigs[cfgIndex].codes.splice(codeIndex, 1);
  }
  addHospitalCode(type: string) {
    this.data.hospitalTracker[type].push('');
  }

  removeHospitalCode(type: string, index: number) {
    this.data.hospitalTracker[type].splice(index, 1);
  }

  save() {
    console.log('Saving...', this.data);
    delete this.data._id;
    // dwonload old data as local file 
    FileUtils.donloadLocalFile(JSON.stringify(this.oldDate), 'old-action-codes.json');
    this.server.postWithToken<any>('snfs/admin/setReportSettings', this.data).subscribe(data => {
      alert('Saved successfully');
    });

    // Example:
    // this.actionService.save(this.actionCodes).subscribe(...)
  }


  trackByIndex(index: number, _item: any) {
    return index;
  }

  onHospitalCodeChange(type: keyof HospitalTracker, index: number, value: string) {
    this.data.hospitalTracker[type][index] = value;
  }


}
